/* Append subsequent Shopify collection pages without replacing the current grid. */
(() => {
  class CollectionLoadMore {
    constructor() {
      this.loadingRoots = new WeakSet();
      document.addEventListener('click', (event) => this.handleClick(event));
    }

    handleClick(event) {
      const button = event.target.closest('[data-load-more-button]');
      const root = button?.closest('.main-collection--root');
      if (!button || !root || this.loadingRoots.has(root)) return;

      event.preventDefault();
      this.load(button.href, root);
    }

    async load(url, root) {
      const grid = root.querySelector('[data-body-grid]');
      const controls = root.querySelector('[data-load-more]');
      if (!grid || !controls || !url) return;

      this.loadingRoots.add(root);
      this.setLoading(root, true);

      try {
        const sectionUrl = new URL(url, window.location.origin);
        sectionUrl.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(sectionUrl);
        if (!response.ok) throw new Error(`Unable to load products (${response.status})`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = documentFragment.querySelector('[data-body-grid]');
        const nextControls = documentFragment.querySelector('[data-load-more]');
        if (!nextGrid || !nextControls) throw new Error('The next collection page could not be read');

        const products = Array.from(nextGrid.children).filter((item) => item.hasAttribute('data-product-item'));
        if (!products.length) throw new Error('The next collection page contains no products');

        grid.append(...products);
        requestAnimationFrame(() => {
          products.forEach((product) => product.setAttribute('data-transition-active', 'true'));
        });
        this.updateControls(root, nextControls);
      } catch (error) {
        this.setError(root);
      } finally {
        this.loadingRoots.delete(root);
        this.setLoading(root, false);
      }
    }

    updateControls(root, nextControls) {
      const controls = root.querySelector('[data-load-more]');
      if (!controls) return;

      controls.dataset.shown = nextControls.dataset.shown;
      controls.dataset.total = nextControls.dataset.total;
      const count = controls.querySelector('[data-load-more-count]');
      const nextCount = nextControls.querySelector('[data-load-more-count]');
      if (count && nextCount) count.textContent = nextCount.textContent;

      const button = controls.querySelector('[data-load-more-button]');
      const nextButton = nextControls.querySelector('[data-load-more-button]');
      if (button && nextButton) {
        button.href = nextButton.href;
        button.removeAttribute('aria-disabled');
      } else if (button) {
        if (document.activeElement === button && count) {
          count.tabIndex = -1;
          count.focus({ preventScroll: true });
        }
        button.remove();
      }
    }

    setLoading(root, isLoading) {
      const button = root.querySelector('[data-load-more-button]');
      const loading = root.querySelector('[data-load-more-loading]');
      const label = root.querySelector('[data-load-more-label]');
      const grid = root.querySelector('[data-body-grid]');
      if (grid) grid.setAttribute('aria-busy', String(isLoading));
      if (!button) return;

      button.setAttribute('aria-disabled', String(isLoading));
      button.classList.toggle('is-loading', isLoading);
      if (loading) loading.hidden = !isLoading;
      if (label) label.hidden = isLoading;
    }

    setError(root) {
      const controls = root.querySelector('[data-load-more]');
      const count = controls?.querySelector('[data-load-more-count]');
      if (count) count.textContent = controls.dataset.errorMessage;
    }
  }

  new CollectionLoadMore();
})();
